import axios from 'axios'
import { API_URL } from '../../config';
import { setLoginToken } from '../../helpers/sessionHandler';

export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'

export const SetAuthenticated = (authenticated) => ({
  type: SET_AUTHENTICATED,
  authenticated: authenticated
})

export const Authenticate = (id, password) => (dispatch) => {
  const credentials = {
    id: id,
    password: password
  }

  axios.post(API_URL+`/auth`, credentials)
    .then(res => {
      const token = res.data.token;
      if(token) {
        dispatch(SetAuthenticated(true))
        setLoginToken(token)
      }
    })
}


// WEBPACK FOOTER //
// ./src/store/authentication/actions.js